// services/authService.js
import axios from "../utils/api";

const signIn = async ({ email, password }) => {
  try {
    const response = await axios.post("/api/auth/signin", { email, password });
    const { token, user, userId } = response.data;

    if (token) {
      localStorage.setItem("token", token);
    }

    return { token, user, userId }; // full object
  } catch (error) {
    console.error("Sign-in error:", error.response?.data || error.message);
    throw error;
  }
};

const validateToken = async () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const response = await axios.get("/api/auth/validate-token", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.user;
  } catch (error) {
    console.error("Token validation error:", error.response?.data || error.message);
    localStorage.removeItem("token");
    return null;
  }
};

const verifyOtp = async ({ userId, otp }) => {
  const response = await axios.post("/api/auth/verify-otp", { userId, otp });
  const { token, user } = response.data;

  if (token) {
    localStorage.setItem("token", token);
  }

  return { user };
};

export default {
  signIn,
  validateToken,
  verifyOtp,
};
